export enum ModelDisplay{
    Hidden,
    Full,
    Half
}